var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrapezoid = function SvgTrapezoid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 212,
    height: 59,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#trapezoid_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.04,
    d: "M2.832 62.481C-4.942 78.424 6.667 97 24.404 97H187.79c17.932 0 29.53-18.95 21.372-34.918l-25.031-49A24 24 0 0 0 162.759 0H48.298a24 24 0 0 0-21.573 13.481z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeOpacity: 0.12,
    d: "M3.282 62.7C-4.33 78.31 7.037 96.5 24.404 96.5H187.79c17.558 0 28.915-18.554 20.927-34.19l-25.031-49A23.5 23.5 0 0 0 162.759.5H48.298a23.5 23.5 0 0 0-21.123 13.2z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "trapezoid_svg__a",
    width: 275.447,
    height: 161,
    x: -31.626,
    y: -32,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "BackgroundImageFix",
    stdDeviation: 16
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2195_7280"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_backgroundBlur_2195_7280",
    result: "shape"
  })))));
};
export default SvgTrapezoid;